<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="internalCorrectiveActionRequestForm" :refresh-key="refreshKey" :show-expand="false" :set-api-data="setApiData">
        <template v-slot:tabs>
            <v-row>
                <v-col>
                    <v-btn-toggle mandatory class="ml-2 float-right" tile color="deep-purple accent-3" group>
                        <v-btn @click="toggleRectified(false)"> Outstanding </v-btn>
                        <v-btn @click="toggleRectified(true)"> Rectified </v-btn>
                    </v-btn-toggle>
                </v-col>
            </v-row>
        </template>
    </table-base>
</template>

<script>
    export default {
        props: [
            'filter'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                internalCorrectiveActionRequestForm: () => import('../forms/InternalCorrectiveActionRequestForm'),
                headers: [
                    { text: 'Internal Member Audit', value: 'internalMemberAuditId', table: 'internalMemberAudits', form: () => import('../forms/InternalMemberAuditForm') },
                    { text: 'Description', value: 'description' },
                    { text: 'Severity', value: 'severity', format: this.formatEnum },
                    { text: 'Raised At', value: 'raisedAt', format: this.formatDateTime },
                    { text: 'Rectify By', value: 'rectifyBy', format: this.formatDate },
                    { text: 'Rectified On', value: 'rectifiedOn', format: this.formatDate },
                    { text: 'Comments', value: 'comments' },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    internalMemberAudits: [],
                    items: []
                },
                sorting: [
                    { column: "raisedAt", direction: "descending" },
                    { column: "description", direction: "ascending" },
                    { column: "internalMemberAuditId", direction: "ascending" },
                ],
                itemsField: 'internalCorrectiveActionRequests',
                editPageName: 'internalCorrectiveActionRequest',
                apiMethod: 'InternalCorrectiveActionRequests',
                claimName: 'InternalCorrectiveActionRequests',
                formTitle: 'Internal Corrective Action Request',
                excelTitle: 'Internal Corrective Action Requests',
                hasEditPage: false,

                displayRectified: false,
                refreshKey: 0,
            }
        },

        methods: {
            setApiData(data) {
                this.$set(this.apiData, 'internalMemberAudits', data.internalMemberAudits);
                this.$set(this.apiData, 'items', data.items.filter(i => this.displayRectified ? i.rectifiedOn !== null : i.rectifiedOn === null));
            },
            toggleRectified(displayRectified) {
                this.displayRectified = displayRectified;
                this.refreshKey += 1;
            }
        }
    };
</script>
